import React, { useContext, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { FixtureDetailsContext } from "../../../../Config/FixtureDetails.jsx";

const EventListItemExtra = (props) => {
  const { event, intl } = props;
  const { formatMessage } = intl;
  const [extraDisplay, setExtraDisplay] = useState("");
  const { sport } = useContext(FixtureDetailsContext);

  useEffect(() => {
    let message = "";
    if (sport === "handball" && event.eventType === "goal") {
      if (event.subType === "sevenMetrePenalty") {
        message = "- " + formatMessage({
          id: "sevenMetrePenalty",
          defaultMessage: "7m Penalty",
        });
      }
    }

    setExtraDisplay(() => <span className={"additional-info"}>&nbsp;{message}</span>);
  }, [event]);

  return <>{extraDisplay}</>;
};

export default injectIntl(EventListItemExtra);
